import { Typography } from '@material-ui/core';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import classNames from 'classnames';
import React, { FC } from 'react';

import { StatusLabelClassNames } from 'src/types';

interface LabelBaseProps {
  className?: string;
  label: string;
  noWrap?: boolean;
}

const LabelBase: FC<LabelBaseProps> = ({ className, label, noWrap = true, ...props }) => (
  <Typography
    className={classNames(StatusLabelClassNames.LABEL, className)}
    component="p"
    noWrap={noWrap}
    title={label}
    variant="overline"
    {...props}
  >
    {label}
  </Typography>
);

interface Label {
  primaryText: string;
  priorityText?: string;
}

export interface LabelProps {
  label: Label;
}

export const Label: FC<LabelProps> = ({ label }) => (
  <>
    <LabelBase
      aria-label={StatusLabelClassNames.PRIMARY_LABEL_TEXT}
      className={StatusLabelClassNames.PRIMARY_LABEL_TEXT}
      label={label.primaryText}
    />
    {label.priorityText && (
      <>
        <FiberManualRecord aria-label={StatusLabelClassNames.DOT} className={StatusLabelClassNames.DOT} />
        <LabelBase
          aria-label={StatusLabelClassNames.PRIORITY_LABEL_TEXT}
          className={StatusLabelClassNames.PRIORITY_LABEL_TEXT}
          label={label.priorityText}
        />
      </>
    )}
  </>
);
